import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { visibleFlightsCountSelector } from 'checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';
import FlightsLoadingResults from './FlightsLoadingResults';
import type { LoadingFlightsProps } from '../types';

const mapStateToProps = (state, props: LoadingFlightsProps) => ({
  visibleFlightsCount: visibleFlightsCountSelector(state),
  isLoading: props.isLoading,
  isMobile: props.isMobile,
  id: props.id,
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(FlightsLoadingResults);
